import { gql } from '@apollo/client';
import { useQuery } from './apollo';

export const PARAM_QUERY = gql`
  query param($paramCode: String!) {
    param(paramCode: $paramCode)
  }
`;

export function useParams(paramCode) {
  const { data: paramData } = useQuery(PARAM_QUERY, {
    variables: { paramCode: paramCode },
    skip: !paramCode
  });

  return paramData?.param;
}
